/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getProjectIdOrKey } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_PROJECT_WORKFLOW_CONTEXT } from './resourceTypeProjectWorkflowContext.constants.tsx';
import type { ProjectWorkflowContext } from './ProjectWorkflowContext.types.tsx';
import getData from './getData.tsx';

export const projectWorkflowContextResource: RouteResource<ProjectWorkflowContext | null> =
	createResource<ProjectWorkflowContext | null>({
		type: RESOURCE_TYPE_PROJECT_WORKFLOW_CONTEXT,
		getKey: (matchedRoute) => getProjectIdOrKey(matchedRoute.match, matchedRoute.query),
		getData,
		maxAge: 0,
		isCritical: true,
		isBrowserOnly: true,
	});

export const useWorkflowProjectContext =
	(): UseResourceHookResponse<ProjectWorkflowContext | null> =>
		useResource<ProjectWorkflowContext | null>(projectWorkflowContextResource);
